<template>
    <base-modal v-bind:modalTitle="'Add Custom Slot'" v-on:save="save()" v-on:close="close()">
        <FormulateForm v-model="model">
            <FormulateInput type="checkbox" name="is_available" label="Available"></FormulateInput>
            <div class="date_input">
                <FormulateInput type="date"
                                name="start_date"
                                label="Start Date"
                                validation="required"
                                :validation-messages="{required: 'Start Date is required'}"
                                @validation="checkValidation" />
                <FormulateInput type="time"
                                name="start_time"
                                label="Start Time"
                                @validation="checkValidation" />
                <FormulateInput type="date"
                                name="end_date"
                                label="End Date"
                                validation="required|afterStart"
                                :validation-rules="{afterStart: afterStart}"
                                :validation-messages="{
                                    required: 'End Date is required',
                                    afterStart: 'End Date must be after Start Date'
                                }"
                                @validation="checkValidation" />
                <FormulateInput type="time"
                                name="end_time"
                                label="End Time"
                                @validation="checkValidation" />
            </div>
        </FormulateForm>
</base-modal>
</template>

<script>
 // Load the full build. 
 var _ = require('lodash');

 import BaseModal from 'components/modals/BaseModal';

 export default {
   components: {
     BaseModal
   },
   props: {
       timeSlot: null
   },
   
   data () {
     return {
         validation: {},
         isValid: false,
         model: {
             id: null,
             start_date: null,
             end_date: null,
             start_time: null,
             end_time: null,
             is_available: false
         }
     };
   },
     computed: {
     },
   created () {
       if (this.timeSlot) {
           this.model = _.clone(this.timeSlot, true);
           this.isValid = true;
       }

       this.model.key = this.model.id ? this.model.id : this.randomId();
   },
   methods: {
       randomId() {
           var r1 = ("0000000" + (Math.random() * 10000000).toFixed()).substr(-7);
           var r2 = ("0000000" + (Math.random() * 10000000).toFixed()).substr(-7);
           return "temp_" + r1 + "_" + r2;
       },
       afterStart(context) {
           try {
               let end_time = context.getFormValues().end_time ? context.getFormValues().end_time : '23:59';
               let start_time = context.getFormValues().start_time ? context.getFormValues().start_time : '00:00';
               let end = new Date(context.getFormValues().end_date + " " + end_time);
               let start = new Date(context.getFormValues().start_date + " " + start_time);
               return end > start;
           } catch(e) {
               return false;
           }
       },
       close() {
           this.$emit('close');
       },
       checkValidation(ev) {
           this.validation[ev.name] = ev;
           let fieldValidations = Object.values(this.validation);
           let res = fieldValidations.length > 0;
           fieldValidations.forEach((field) =>  {
               res = res && !field.hasErrors;
           });
           this.isValid = res;

       },
       save() {
           if (this.isValid) {
               if (!this.model.start_time) {
                   this.model.start_time = '00:00';
               }
               if (!this.model.end_time) {
                   this.model.end_time = '23:59';
               }
               this.$emit('save', this.model);
           }
       }
   }

 }
</script>


<style scoped>
.multiple-choices > div.formulate-input-group {
  height: 200px;
  max-height: 200px;
  overflow: auto;
  overscroll-behavior: contain;
  border: 1px solid #ddd;
  padding: 10px 10px;
  border-radius: 4px 4px 4px 4px;
 }
 .date_input {
     display: grid;
     grid-template-columns: 2fr 1fr;
     column-gap: .5em;
 }
</style>



// WEBPACK FOOTER //
// AgentScheduleCustomSlotModal.vue?beb323a2